export default "__VITE_ASSET__D$_SvRe$__"